import { Clock, Mail, MapPin, Phone } from "lucide-react";
import Header from "@/components/Header";
import Seo from "@/components/Seo";
import ContactBar from "@/components/ContactBar";
import ContactForm from "@/components/ContactForm";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import { lines, sz, txt, useContent } from "@/content/ContentContext";
import { buildContactFaqs, resolveFaqs } from "@/content/faqData";
import { PAGE_META, breadcrumbSchema } from "@/content/seoData";

const Contact = () => {
  const c = useContent();
  const cp = c.contact;
  const cb = c.global.contactBar;

  return (
    <div className="App" data-testid="contact-page">
      <Seo
        title={PAGE_META.contact.title}
        description={PAGE_META.contact.description}
        path="/contact"
        schemas={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Contact", path: "/contact" },
          ]),
        ]}
      />
      <Header />
      <main>
        <section className="svcpage-hero contactpage-hero">
          <Reveal y={20}>
            <h1 className="svcpage-title" style={sz(cp.titleStart)} data-testid="contact-page-title">
              {txt(cp.titleStart)}{" "}
              <span className="text-green" style={sz(cp.titleAccent)}>{txt(cp.titleAccent)}</span>
            </h1>
            <p className="svcpage-intro" style={sz(cp.intro)}>{lines(cp.intro)}</p>
          </Reveal>
          <Reveal className="contactpage-details" y={18} delay={0.12}>
            <div className="cpd-item">
              <Mail className="cpd-icon" strokeWidth={1.6} />
              <div>
                <span className="cpd-label">Email</span>
                <a href={`mailto:${cb.email}`} data-testid="contact-page-email">{cb.email}</a>
              </div>
            </div>
            <div className="cpd-item">
              <Phone className="cpd-icon" strokeWidth={1.6} />
              <div>
                <span className="cpd-label">Phone</span>
                <a href={`tel:${cb.phone.replace(/[^+\d]/g, "")}`} data-testid="contact-page-phone">{cb.phone}</a>
              </div>
            </div>
            <div className="cpd-item">
              <Clock className="cpd-icon" strokeWidth={1.6} />
              <div>
                <span className="cpd-label">Hours</span>
                <span className="cpd-value" style={sz(cp.hours)} data-testid="contact-page-hours">{txt(cp.hours)}</span>
              </div>
            </div>
            <div className="cpd-item">
              <MapPin className="cpd-icon" strokeWidth={1.6} />
              <div>
                <span className="cpd-label" style={sz(cp.addressLabel)}>{txt(cp.addressLabel)}</span>
                <span className="cpd-value" style={sz(cp.address)} data-testid="contact-page-address">
                  {lines(cp.address)}
                </span>
              </div>
            </div>
          </Reveal>
        </section>
        <ContactForm />
        <FAQSection items={resolveFaqs(c, "contact", buildContactFaqs(c))} />
      </main>
      <ContactBar />
      <Footer />
    </div>
  );
};

export default Contact;
